"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _ = require("_");

var _immutable = require("immutable");

var _UserSettingsStore = _interopRequireDefault(require("crm_data/settings/UserSettingsStore"));

var _default = function _default() {
  for (var _len = arguments.length, keys = new Array(_len), _key = 0; _key < _len; _key++) {
    keys[_key] = arguments[_key];
  }

  return function () {
    var settings = _UserSettingsStore.default.get(_immutable.Seq.Set(keys).toMap());

    if (settings.some(_.isUndefined)) {
      return undefined;
    }

    return settings;
  };
};

exports.default = _default;
module.exports = exports.default;